import * as pdfjsLib from 'pdfjs-dist';

/**
 * unpkg mirrors npm packages directly (cdnjs is missing some pdfjs-dist
 * versions), and the worker must be the `.min.mjs` build because pdfjs-dist
 * 4.x ships an ES module worker. The cMap and standard-font URLs are what make
 * CID fonts — every Japanese PDF — render instead of coming out blank.
 */
export const PDFJS_ASSET_BASE_URL = `https://unpkg.com/pdfjs-dist@${pdfjsLib.version}`;
export const PDFJS_WORKER_SRC = `${PDFJS_ASSET_BASE_URL}/build/pdf.worker.min.mjs`;
export const PDFJS_CMAP_URL = `${PDFJS_ASSET_BASE_URL}/cmaps/`;
export const PDFJS_STANDARD_FONT_DATA_URL = `${PDFJS_ASSET_BASE_URL}/standard_fonts/`;

pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS_WORKER_SRC;

export const PDF_DEFAULT_SCALE = 1.2;
export const PDF_MIN_SCALE = 0.5;
export const PDF_MAX_SCALE = 3;
export const PDF_SCALE_STEP = 0.2;

/** Pre-load pages 200px before they scroll into view. */
export const PDF_OBSERVER_ROOT_MARGIN = '200px 0px';
export const PDF_OBSERVER_THRESHOLD = 0.1;

export const PDF_PAGE_GAP_PX = 20;
export const PDF_PAGE_SHADOW = '0 0 10px rgba(0, 0, 0, 0.3)';
export const PDF_PAGE_BACKGROUND = 'white';
export const PDF_PAGE_PLACEHOLDER_BACKGROUND = '#f0f0f0';
export const PDF_PAGE_PLACEHOLDER_COLOR = '#999';
export const PDF_PAGE_PLACEHOLDER_FONT_SIZE = '24px';

/**
 * The match rectangles are painted into an imperative layer over the canvas, so
 * they cannot be Tailwind classes. The minimap markers and the selected results
 * row repeat this same orange on purpose — the list row has to read as the same
 * mark the reader sees on the page — but they need hover states, so they carry
 * it as arbitrary Tailwind values instead.
 */
export const PDF_HIGHLIGHT_CURRENT_FILL = 'rgba(255, 165, 0, 0.5)';
export const PDF_HIGHLIGHT_FILL = 'rgba(255, 255, 0, 0.4)';
export const PDF_HIGHLIGHT_UNDERLINE = '2px solid #ffcc00';

export const PDF_MINIMAP_WIDTH_PX = 24;
export const PDF_MINIMAP_MARKER_INSET_PX = 2;
export const PDF_MINIMAP_MARKER_HEIGHT_PX = 4;
